import $ from "jquery";

class Calculations {
    constructor() {
        $(document).ready(() => {
            this.$wordResults = $('.js-results-word');
            this.$mobileWordResults = $('.js-results-word-mobile');
            this.$resultsContainer = $('.js-current-results-container');
            this.$deleteResult = $('.js-delete-result');
            this.$backPopup = $('.js-calc-results-popup-back');
            this.$deleteResultPopup = $('.js-delete-result-mobile');
            this.hookListeners();
        });
    }

    hookListeners() {
        var showLoaderEvent = new Event('loader.show');
        var hideLoaderEvent = new Event('loader.hide');

        this.$wordResults.click(function() {
            let word = $(this).text();
            document.dispatchEvent(showLoaderEvent);

            var data = {
                'action': 'get_current_word_results_ajax_request',
                'post_type': 'GET',
                'word': word
            };
            var url = '/wp-admin/admin-ajax.php';
            $('.c-gematry-calculators__shadow').css('opacity', '0.4');

            $.get(url, data, function (response) {
                let results = $('.js-current-results-container');
                results.html('');

                response["results"].forEach(function (item, index) {
                    if(item["breakdown"] == undefined) {
                        item["breakdown"] = '';
                    }
                    else {
                        item["breakdown"] = '<br><br>' + item["breakdown"];
                    }

                    results
                        .append(
                            '<div class="c-calculators-results__current-result-container">' +
                            '<h3 class="c-gematry-calculators__calc-value c-calculators-results__calc-number">' + item["result"] + '</h3>' +
                            '<div class="c-calculators-results__current-result-calc-name">' + item["calculator"] + item["breakdown"] + '</div>' +
                            '</div>'
                        );
                });
                document.dispatchEvent(hideLoaderEvent);
            }, 'json');
        });

        this.$deleteResult.click(function () {
            let result_container = $(this).parent();
            let word = $(result_container).find('.js-results-word').text();
            var data = {
                'action': 'delete_result_ajax_request',
                'post_type': 'POST',
                'word': word
            };
            var url = '/wp-admin/admin-ajax.php';

            $.post(url, data, function (response) {
                $(result_container).animate({
                    "opacity": "0",
                }, 1000, function() { $(this).remove(); });
            });
        });

        this.$mobileWordResults.click(function() {
            $('.js-calculator-results-popup').css('display', 'flex');
            $('.js-calc-results-popup-word').text($(this).text());
        });

        this.$backPopup.click(function() {
            $('.js-calculator-results-popup').fadeOut();
        });

        this.$deleteResultPopup.click(() => {
            document.dispatchEvent(showLoaderEvent);
            let word = $('.js-calc-results-popup-word').text();

            let result_container = $('.js-word-container-mobile[data-word="' + word + '"]');
            var data = {
                'action': 'delete_result_ajax_request',
                'post_type': 'POST',
                'word': word
            };
            var url = '/wp-admin/admin-ajax.php';

            $.post(url, data, function (response) {
                $(result_container).animate({
                    "opacity": "0",
                }, 1000, function() { $(this).remove(); });

                $('.js-calculator-results-popup').fadeOut();
                document.dispatchEvent(hideLoaderEvent);
            });
        });
    }
}

export default Calculations;